import { create } from "zustand";

interface MobileNavState {
  open: boolean;
  toggle: () => void;
  setOpen: (open: boolean) => void;
}

export const useMobileNavStore = create<MobileNavState>((set) => ({
  open: false,
  toggle: () => set((state) => ({ open: !state.open })),
  setOpen: (open) => set({ open }),
}));
